export const pricingFieldHelp = {
  marginDefault: {
    description:
      'Percentual de margem aplicado por padrão nas simulações, quando o lucro desejado não é informado.',
    example: '30 (30% sobre o custo)',
  },
  taxDefault: {
    description: 'Alíquota de impostos embutida no preço de venda nas simulações e cotações.',
    example: '14,25',
  },
  name: {
    description: 'Nome comercial da feature, como aparece no catálogo e na cotação para o cliente.',
    example: 'Licença de Uso (mensal)',
  },
  code: {
    description:
      'Identificador interno. Digite só letras minúsculas, números e hífen. Espaços, acentos e outros caracteres não são aceitos.',
    example: 'licenca-btalk',
  },
  product: {
    description:
      'Produto comercial ao qual este custo se aplica. Use “Todos os produtos” se o item vale para qualquer oferta.',
    example: 'bTalk — Plataforma de Inteligência Conversacional',
  },
  kind: {
    description:
      'Como o item entra na simulação. Flag = inclui ou não (módulo extra). Contador = cobra pela quantidade. Contador c/ desconto progressivo = quantidade com faixas de preço.',
    example: 'Contador — para licenças, seats ou unidades mensais',
  },
  costSetup: {
    description: 'Custo único de implantação ou onboarding deste item, em reais. Use 0 se não houver setup.',
    example: '3500',
  },
  costUnit: {
    description:
      'Custo recorrente mensal (MRR) por unidade. Use 0 quando o item for cobrado só no setup.',
    example: '2390',
  },
  includedQuantity: {
    description:
      'Quantidade já coberta pelo custo informado, sem excedente. Em Flag, use 1. Em Contador, use o volume mínimo do pacote.',
    example: '1 (uma licença inclusa no valor)',
  },
  description: {
    description: 'Texto curto explicando o que o cliente está comprando com este item. Complementa o nome e o código.',
    example: 'Licença de uso da ferramenta',
  },
  simProduct: {
    description: 'Filtra o catálogo usado nesta simulação. Itens genéricos (sem produto) entram em qualquer filtro.',
    example: 'bTalk — Plataforma de Inteligência Conversacional',
  },
  simMargin: {
    description:
      'Margem sobre o custo para formar o preço de venda. Fica desabilitada se o lucro desejado estiver preenchido.',
    example: '30',
  },
  simTax: {
    description: 'Alíquota de impostos aplicada sobre o preço de venda desta simulação.',
    example: '14,25',
  },
  simDesiredProfit: {
    description:
      'Simulação reversa: o sistema calcula a margem necessária para atingir esse lucro. Se preenchido, o campo Margem é ignorado.',
    example: '15000',
  },
  simMonths: {
    description: 'Duração do contrato em meses, usada no total do período (setup + MRR × meses).',
    example: '12',
  },
  quoteTitle: {
    description: 'Nome da cotação no histórico, para localizar depois a proposta enviada.',
    example: 'Proposta bTalk — Empresa X',
  },
  quoteCompany: {
    description: 'Cliente já cadastrado ao qual esta cotação se refere. Opcional se ainda for um lead.',
    example: 'selecione a empresa do contrato',
  },
  quoteProspect: {
    description: 'Lead ainda não convertido, quando a cotação nasce da prospecção.',
    example: 'selecione o prospect da oportunidade',
  },
  quoteOpportunity: {
    description: 'Negócio no pipeline comercial vinculado a esta proposta.',
    example: 'selecione a oportunidade em andamento',
  },
  quoteNotes: {
    description: 'Contexto interno da cotação (condições especiais, premissas ou ressalvas).',
    example: 'Setup com 10% de desconto no primeiro mês',
  },
} as const;
